/* global APP_NAME */
/* global gtag */
/* global fbq */
/* global STAGE */
/* global NATIVE */
/* global __kdt */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import User from '@/connection/user'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMq from 'vue-mq'
import { Layout } from 'bootstrap-vue/es/components'
import axios from 'axios'
import LocationConn from '@/connection/location'

axios.interceptors.response.use(
  response => {
    return response
  }, async error => {
    if(!error.response) {
      console.log(error)
      return Promise.reject(error)
    } else if (error.response.status === 401) {
      await User.logout(true)
      router.push({path: '/login'})
      return Promise.resolve(error)
    } else {
      return Promise.reject(error.response.data)
    }
  }
)

Vue.use(Layout)

var getJSON = function(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'json';
  xhr.onload = function() {
    var status = xhr.status;
    if (status === 200) {
      callback(null, xhr.response);
    } else {
      callback(status, xhr.response);
    }
  };
  xhr.send();
};

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 1024,
    desktop: Infinity,
  }
})

library.add(fas, far, fal, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// load service worker
if (NATIVE === false && navigator.serviceWorker) {
  navigator.serviceWorker.register('/OneSignalSDKWorker.js')
} else {
  console.log('not navigator service worker')
}

getJSON( store.state.opaApi[STAGE] + '/company/domain/' + APP_NAME,
 function(err, data) {
  if (err !== null) {
    console.log('ERROR!', err)
    alert('Something went wrong: ' + err);
  } else {
    new Vue({
      router,
      store,
      async beforeCreate() {
        // get user data from localstorage if exists
        this.$store.commit('setLoadingView',true)
        if (localStorage.getItem('user')){
          this.$store.commit('setUser', JSON.parse(localStorage.getItem('user')))
        }
        let storeBrand = data
        this.$store.commit('setCompany', storeBrand)
        console.log(storeBrand)
        document.title = storeBrand.companyBrand
        //after get store and your keys start onesignal
        if (NATIVE === false && storeBrand.onSignalKeys && storeBrand.onSignalKeys.appId) {
          try {
            var OneSignal = window.OneSignal || []
            console.log('OneSignal', storeBrand.onSignalKeys.appId)
            OneSignal.push(['init', {appId: storeBrand.onSignalKeys.appId, autoRegister: true}])
            OneSignal.on('subscriptionChange', function (isSubscribed) {
              console.log("The user's subscription state is now: " + isSubscribed)
              OneSignal.getUserId(function(userId) {
                console.log("OneSignal User ID:", userId);
                localStorage.setItem('pushUserId', userId)
              });
            })
            OneSignal.on('notificationPermissionChange', function (permissionChange) {
              console.log('permission change', permissionChange)
              OneSignal.setSubscription(true)
              OneSignal.getUserId(function(userId) {
                console.log("OneSignal User ID:", userId);
                localStorage.setItem('pushUserId', userId)
              });
            })
            navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((r) => {r.update()}).catch((e) => {console.log(e)})
          } catch(e) {
            console.log(e)
          }
        } else if (NATIVE === true){
          //native push configuration
          if (storeBrand.onSignalKeys && storeBrand.onSignalKeys.appId) {
            document.addEventListener('deviceready', function () {
              // Enable to debug issues.
              console.log('DEVICE READY!!!')
              var notificationOpenedCallback = function(jsonData) {
                console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
              };

              window.plugins.OneSignal
                .startInit(storeBrand.onSignalKeys.appId)
                .handleNotificationOpened(notificationOpenedCallback)
                .endInit();

              window.plugins.OneSignal.provideUserConsent(true);

            }, false);
          }
        } else {
          navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((r) => {r.update()}).catch((e) => {console.log(e)})
        }

        // google analytics
        if (storeBrand.googleKeys.googleKeyAnalytics) {
          this.$store.state.googleKeyAnalytics = storeBrand.googleKeys.googleKeyAnalytics
          var currentPath = this.$route.path
        }
        if (storeBrand.facebookPixel) {
          this.$store.state.facebookPixel = storeBrand.facebookPixel
        }
        if (storeBrand.googleKeys.googleKeyAnalytics) {
          (function(w,d,s,l,i){
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtag/js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
            j.onload = () => {
              gtag('config', i, {'page_path': currentPath})
            }
          }).bind(this)(window, document, 'script', 'dataLayer', storeBrand.googleKeys.googleKeyAnalytics)
        }
        // // google tagmanager
        if (storeBrand.googleKeys.googleKeyTagManager) {
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',storeBrand.googleKeys.googleKeyTagManager)
        }
        // konduto
        if( storeBrand.konduto && storeBrand.konduto.public_key) {
          __kdt.push({"public_key": storeBrand.konduto.public_key});
          __kdt.push({"post_on_load": false});   // Envio automático desativado
          console.log(__kdt);
          (function() {
            var kdt = document.createElement('script');
            kdt.id = 'kdtjs'; kdt.type = 'text/javascript';
            kdt.async = true;
            kdt.src = 'https://i.k-analytix.com/k.js';
            var s = document.getElementsByTagName('body')[0];
            console.log(s)
            s.parentNode.insertBefore(kdt, s);
          })();
        }
        // facebook pixel
        if(storeBrand.facebookPixel) {
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', storeBrand.facebookPixel);
          fbq('track', 'PageView');
        }

        // lock initial store if marketplace or crowdsales
        if (storeBrand.block_address_navigation && storeBrand.block_address_navigation !== 'NO') {
          console.log('MARKET PLACE')
          // if user is logged and to have address
          if (this.$store.state.user && this.$store.state.user.adresses.length) {
            let addr = this.$store.state.user.adresses[this.$store.state.user.adresses.length -1]
            // add the selected ID to session for use in checkout
            this.$store.state.selectedAddressId = addr.id
            // addr short name to selects
            this.$store.state.selectedAddressShort = addr.shortName
            if (this.$store.state.company.block_address_navigation === "YES_LIST") {
              this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
              this.$router.push({path: '/company_list/' + addr.latLong.lat + '/' + addr.latLong.lng})
              this.$store.commit('setLoadingView',false)
            } else {
              //Auto choice and go to home

              // flag the need of address alertModal
              this.$store.state.addressAlertModal = true

              //this.$router.push({path: '/'})
              this.$store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
              console.log('WAIT GET SUBCOMPANY')
              let result = await LocationConn.getCompaniesByLocation(addr.latLong.lat, addr.latLong.lng)
              console.log(result)
              if (!result.error && result.length){
                let companyResult = result[0]
                this.$store.commit('setProducts', [])
                this.$store.commit('setProductList', [])
                this.$store.commit('setCategories', [])
                this.$store.state.fetchingAllProducuts = false
                this.$store.commit('setChoicedCompanyId', companyResult.companyId)
                this.$store.commit('setChoicedCompany', companyResult)
                console.log('GO TO PATH')
                this.$router.push({path:'/home'})
                this.$store.commit('setLoadingView',false)
              } else {
                console.log('NOT ATTEND')
                // TODO full page not attend fall back not region to be
                this.$router.push({path: '/company_list/' + addr.latLong.lat + '/' + addr.latLong.lng})
                this.$store.commit('setLoadingView',false)
              }
            }
          } else {
            console.log(this.$route)
            // if marketplace land with cep input redirect to company list
            if (this.$route.query.auto && this.$route.query.auto === 'true') {

              this.$store.state.lastLatLongUri = this.$route.query.lat + '/' + this.$route.query.lng
              this.$router.push({path: '/company_list/' + this.$route.query.lat + '/' + this.$route.query.lng})
              this.$store.commit('setLoadingView',false)
            } else if (this.$route.query.welcomelogin && this.$route.query.welcomelogin === 'true') {
              // go to welcome page
              this.$router.push({path:'/welcome/?login=true'})
              this.$store.commit('setLoadingView',false)
            } else if (this.$route.query.welcomeregister && this.$route.query.welcomeregister === 'true') {
              // go to welcome page
              this.$router.push({path:'/register/?ref=' + this.$route.query.ref})
              this.$store.commit('setLoadingView',false)
            } else {
              // go to welcome page
              this.$router.push({path:'/welcome'})
              this.$store.commit('setLoadingView',false)
            }
          }
        } else {
          this.$store.commit('setLoadingView',false)
        }

      },
      render: h => h(App)
    }).$mount('#app')
  }
});


